import styled from "styled-components"
import SegueLink from "app/static/frontend/middleware/SegueLink"
import { HyperLinkColor } from "app/static/frontend/design-constants"

export const PotentialDuplicateRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
`

export const Text = styled.span`
    font-size: 16px;
    margin-right: 10px;
`

export const StyledLink = styled(SegueLink)`
    font-weight: 500;
    color: ${HyperLinkColor};
`

export const MergeButtonContainer = styled.div`
    margin-right: 11px;
`

export const IgnoreButtonContainer = styled.div``

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
`
